export default "__VITE_ASSET__DtU$ywSH__"